import { BookingStatusModel } from './booking-status-model';
import { GuestDetailsPayload } from 'app/model/checkout/guest-info.model';
import { BookingApprovalModel } from 'app/model/booking/booking-list.model';

export class BookingDetailModel {
  bookingId: string;
  bookingProductId: string;
  bookingApproval: BookingApprovalModel
  lang: string;
  fullName: string;
  phone: string;
  email: string;
  memberId: string;
  productName: string;
  productAddress: string;
  productPhone: string;
  photoUrl: string;
  currencyCode: string;
  checkInDate: string;
  checkOutDate: string;
  cancellationDate: string;
  company: CompanyModel;
  bookingProductItems: BookingProductItemsModel[];
  roomCount: string;
  allGuest: string;
  totalPriceExcludeVat: string;
  totalVat: string;
  totalPrice: string;
  ratingStar: number;
  latitude: number;
  longitude: number;
  dateOrder: string;
  checkInTimeFrom: string;
  checkInTimeUntil: string;
  checkOutTimeFrom: string;
  checkOutTimeUntil: string;
  paymentMethod: string;
  paymentDate: string;
  dateTimeToPay: string;
  wsReference: string;
  paymentType: string;
  bookingStatus: string;
  paymentStatus: string;
  cancelStatus: string;
  cancellationChargeList: any;
  cancellationFee: string;
  isOldBooking: boolean;
  reporters: any;
  files: any;
  rooms: GuestDetailsPayload;
  orderStatus: BookingStatusModel;
}

export class CompanyModel {
  address: string;
  companyId: number;
  name: string;
  taxNo: string;
}

export class BookingProductItemsModel {
  breakfast: boolean;
  guests: GuestDetailModel[];
  optionCondition: string;
  priceSelling: string;
  priceSellingTotal: string;
  quantity: string;
  rowIndexNo: string;
  cancellationConditionList: CancellationConditionDetail[];
}

export class CancellationConditionDetail {
  message: string;
}

export class GuestDetailModel {
  name: string;
  no: number;
  requirement: string;
}

export class DisplayBookingDetailDTO {
  productName: string;
  productAddress: string;
  ratingStar: number[];
  orderDate: string;
  orderTime: string;
  dateTimeToPay: string;
  paymentDate: string;
  cancelDate: string;
  cancellationCharge: string;
  refund: string;
  dayCheckIn: string;
  checkInDate: string;
  dayCheckOut: string;
  checkOutDate: string;
  phone: String;
}


// WEBPACK FOOTER //
// ./src/app/model/booking/booking-detail-model.ts